var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32422 1.42578V9.57422H6V10.75H1.32422C1.01432 10.75 0.740885 10.6315 0.503906 10.3945C0.285156 10.1576 0.175781 9.88411 0.175781 9.57422V1.42578C0.175781 1.11589 0.285156 0.842448 0.503906 0.605469C0.740885 0.36849 1.01432 0.25 1.32422 0.25H6V1.42578H1.32422ZM8.92578 2.57422L11.8242 5.5L8.92578 8.42578L8.10547 7.57812L9.60938 6.07422H3.67578V4.92578H9.60938L8.10547 3.39453L8.92578 2.57422Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-logout.05c81398.svg";
export { ForwardRef as ReactComponent };